import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { BottomNav } from "./BottomNav";
import { applySeo } from "../lib/seo";

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    applySeo({
      title: "Portal",
      description: "CELSZC staff and member portal.",
      path: typeof window !== "undefined" ? window.location.pathname : "/admin",
      noindex: true,
    });
  }, []);

  return (
    <div className="portal-shell overflow-x-hidden font-sans antialiased min-h-[100svh]">
      <Header onMenuClick={() => setSidebarOpen(true)} />

      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <main className="flex-1 lg:ml-64 transition-all duration-300 pt-[calc(4rem+env(safe-area-inset-top))] min-w-0 min-h-[calc(100svh-4rem-env(safe-area-inset-top))] pb-[calc(4.5rem+env(safe-area-inset-bottom))] lg:pb-8 overflow-x-hidden">
          <div className="min-w-0 w-full p-3 sm:p-6 lg:p-8 overflow-x-hidden">
            <Outlet />
          </div>
        </main>
      </div>

      <BottomNav onMenuClick={() => setSidebarOpen(true)} />
    </div>
  );
}
